export enum TipoLogisticaEnum {
  Correios    = 1,
  Customizado = 2,
}
